/**
 * `attendance_monthly` analitikasidagi `matrix` uchun sof yordamchilar
 * (holat matritsasi va jadvaldagi kun chizig'i BITTA sana to'plamidan
 * quriladi).
 *
 * ⚠️ `matrix[].days` — faqat O'SHA xodimning `attendance_days`
 * qatorlari: har xil jadvaldagi xodimlarning sanalari farq qiladi.
 * Ustunlar shu sababli barcha qatorlar sanalarining BIRLASHMASIDAN
 * olinadi — aks holda ikki xodimning chizig'i ustma-ust tushmasdi va
 * «N kun» sarlavhasi yolg'on bo'lardi.
 */

export interface MatritsaKuni {
	date: string;
	status: string;
}

/** Barcha qatorlar sanalari — takrorsiz, o'sish tartibida (`YYYY-MM-DD` satr tartibi). */
export function matritsaSanalari(qatorlar: readonly { days: readonly MatritsaKuni[] }[]): string[] {
	const sanalar = new Set<string>();
	for (const qator of qatorlar) {
		for (const kun of qator.days) {
			sanalar.add(kun.date);
		}
	}
	return [...sanalar].sort();
}

/** Sana → holat xaritasi; qatorda yo'q sana `undefined`. */
export function sanaBoyichaHolat(kunlar: readonly MatritsaKuni[]): Map<string, string> {
	return new Map(kunlar.map((k) => [k.date, k.status]));
}
